const appIsSyncing = state => appId => state.appSyncTimeoutIntervalIds[appId];

export default {
    appIsSyncing,
};
